import React from 'react';
import { compose } from 'redux';
import { LocalizedMessage, LocalizedStandardDate } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Core components
import Badge from 'components/core/Badge';
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
import Tooltip from 'components/core/Tooltip';
// Models
import { lastStatus, devicesQtities } from 'models/rollout';
// Custom
import { listRowSpecsShape, rolloutDataShape } from 'constants/PropTypesShapes';
import { showPath } from 'rollouts/navigation';
import { EditIconButton, ShortcutIconButton } from 'components/buttons/IconButtons';
import withLoading from 'hocs/WithLoading';
import AppIcon from 'components/icons/AppIcon';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';
import InfoCheckbox from 'components/misc/InfoCheckbox';
import DistributionLink from 'distributions/assets/main/DistributionLink';

const RolloutDevices = ({ rollout }) => (
  <div className="d-flex">
    {_map(devicesQtities(rollout), (devicesQtity) => {
      const { status, qtity } = devicesQtity;
      const { value, icon, color } = status;
      return (
        <Tooltip key={value} content={<LocalizedMessage id={`devicesQtity.rolloutStatus.${value}`} values={{ qtity }} />}>
          <div className="mr-3">
            <Badge content={qtity} backgroundColor={color} type="small">
              <AppIcon id={icon} color={color} />
            </Badge>
          </div>
        </Tooltip>
      );
    })}
  </div>
);

RolloutDevices.propTypes = {
  rollout: rolloutDataShape.isRequired,
};

const RolloutStatus = ({ rollout }) => {
  const statusObj = lastStatus(rollout);

  if (statusObj) {
    const { labelId, icon, color } = statusObj.status;
    return (
      <div className="d-flex align-items-center">
        <Tooltip
          content={(
            <div>
              <div className="row m-0">
                <LocalizedStandardDate value={statusObj.date} />
              </div>
              <div className="row m-0">
                <em><LocalizedMessage id={labelId} /></em>
              </div>
            </div>
          )}
        >
          <AppIcon id={icon} color={color} />
        </Tooltip>
      </div>
    );
  }
  return null;
};

RolloutStatus.propTypes = {
  rollout: rolloutDataShape.isRequired,
};

const RolloutRow = React.forwardRef(({
  rollout, rowSpecs, withLink, handleStartLoading,
}, ref) => {
  const { id: rolloutId } = rollout;

  return (
    <TableRow
      ref={ref}
      element={rollout}
      rowSpecs={rowSpecs}
      actions={
        withLink ? [
          <ShortcutIconButton key="bLink" primary path={showPath(rolloutId)} />,
        ] : [
          <EditIconButton key="bEdit" onClick={handleStartLoading} path={showPath(rolloutId)} />,
        ]
      }
    >
      <TableCell>
        <TruncatedTooltipText>
          <LocalizedStandardDate value={rollout.date} />
        </TruncatedTooltipText>
      </TableCell>
      <TableCell className="hidden-sm-down">
        <DistributionLink distribution={rollout.distribution} />
      </TableCell>
      <TableCell className="table-content-2 table-content-center hidden-md-down">
        <InfoCheckbox value={rollout.force_complete_update} />
      </TableCell>
      <TableCell className="table-content-1 table-content-center" noPadding>
        <RolloutStatus rollout={rollout} />
      </TableCell>
      <TableCell className="hidden-sm-down" noPadding>
        <RolloutDevices rollout={rollout} />
      </TableCell>
    </TableRow>
  );
});

RolloutRow.displayName = 'RolloutRow';

RolloutRow.propTypes = {
  rollout: rolloutDataShape.isRequired,
  rowSpecs: listRowSpecsShape.isRequired,
  withLink: PropTypes.bool,
  handleStartLoading: PropTypes.func.isRequired,
};

RolloutRow.defaultProps = {
  withLink: false,
};

module.exports = compose(
  withLoading,
)(RolloutRow);



// WEBPACK FOOTER //
// ./routes/app/routes/rollouts/assets/main/RolloutRow.js